import { Capacitor } from "@capacitor/core";
import { usePwaStore } from "~/stores/usePwaStore";

export default defineNuxtPlugin((_) => {
  if (Capacitor.isNativePlatform()) return;
  // Register service worker to tell the browser this is a Progressive Web App.
  usePwaStore().register();
});
